import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-php-redirect',
  standalone: true,
  template: `
  `
})
export class PhpRedirectComponent implements OnInit {
  redirectUrl = '/assets/chat-overlay-test.html';

  ngOnInit(): void {
    // Get current URL parameters and pass them to the HTML file
    const urlParams = new URLSearchParams(window.location.search);
    const params = urlParams.toString();
    
    if (params) {
      this.redirectUrl += '?' + params;
    }
    
    // Redirect after a short delay
    setTimeout(() => {
      window.location.href = this.redirectUrl;
    }, 1000);
  }
}
